import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { DEFAULT_SIGNING_MUTATION_PARAMS } from "@/modules/patients/detail/conclude/services/useDocumentSigning"
import {
  De_signPrescriptionDocumentInput,
  useDeSignPrescriptionMutation as useDeSignPrescriptionMutationType,
} from "@/modules/patients/detail/prescription/de/services/__generated__/useDeSignPrescriptionMutation.graphql"

const mutation = graphql`
  mutation useDeSignPrescriptionMutation($input: De_signPrescriptionDocumentInput!) {
    de_signPrescriptionDocument(input: $input) {
      qesSigningResponse {
        requestId
        signingRequestUrl
      }
      errors {
        ... on SignDocumentMutationFailed {
          errorType
          message
        }
      }
    }
  }
`

type Config = Omit<UseMutationConfig<useDeSignPrescriptionMutationType>, "variables"> & {
  id: De_signPrescriptionDocumentInput["id"]
}

const useDeSignPrescriptionMutation = () => {
  const [commit, isFlight] = useMutationWithErrorDialog<useDeSignPrescriptionMutationType>(
    mutation,
    DEFAULT_SIGNING_MUTATION_PARAMS,
  )

  const commitHandler = useCallback(
    async (config: Config) => {
      return commit({
        variables: {
          input: {
            id: config.id,
          },
        },
        ...config,
      })
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useDeSignPrescriptionMutation }
